// This differs from the parent only in that we redirect to a symplr
// page on Hubspot form submission instead of redirecting to the PDF.

$(() => {
  function launch_pdf_using_hubspot() {
    const handle_pdf_click = function() {
      const missing_required = $(this).closest('form').find('input[required]').filter(function() {
        return $(this).val().length === 0;
      });

      // We can't use Hubspot's onFormSubmit handler, because it triggers the browser's pop-up blocker,
      // so make sure required fields are filled out
      if (missing_required.length > 0) {
        return false;
      }

      $('#sent-prospect-email').val('true');
      $('#calculator-form').submit();
      return window.open('https://www.symplr.com/cvo-value-calculator-thank-you');
    };

    $('body').on('click', '#download-pdf-link', (event) => {
      if ($('iframe').length) {
        event.preventDefault();
        $('#download-modal').modal('show');
        $('iframe').contents().on('click', '.hs-button', handle_pdf_click);
      } else { // we're in the test env or the user has an ad blocker
        $('#sent-prospect-email').val('true');
        $('#calculator-form').submit();
        $('#ad-blocker-modal').modal();

        $.ajax({
          url: '/ad_block_logs',
          type: 'POST',
          beforeSend(xhr) { xhr.setRequestHeader('X-CSRF-Token', $('meta[name="csrf-token"]').attr('content')); },
          data: `cvm_session_id=${$('#cvm-session-id').val()}&calculator_id=${$('#calculator-id').val()}`
        });
      }
    });
  }

  launch_pdf_using_hubspot();
});
